import { render, staticRenderFns } from "./ApplicationContainer.vue?vue&type=template&id=072c8426&scoped=true&"
import script from "./ApplicationContainer.vue?vue&type=script&lang=ts&"
export * from "./ApplicationContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c8426",
  null
  
)

export default component.exports